// 状态存储
var state = {
  treeData: [], // 导航树数据
  storeData: [], // 轨迹存储
  historyStoreData: [], // 历史数据存储
  currentStoreData: {}, // 当前数据
  selectData: [] // 存储多选数据
}
// 同步方法
const mutations = {
  SET_TREE_DATA: (state, data) => {
    state.treeData = data
  },
  SET_STORE_DATA: (state, data) => {
    state.storeData = data
  },
  SET_CURRENT_STORE_DATA: (state, data) => {
    state.currentStoreData = data
  },
  SET_HISTORY_STORE_DATA: (state, data) => {
    if(data==null){
      state.historyStoreData = []
    }else{
      state.historyStoreData.push(data)
      if(state.historyStoreData.length>10){
        state.historyStoreData.shift()
      }
    }

  },
  DEL_STORE_DATA_ONE: (state, data) => {
    const tmpState = []
    state.storeData.forEach(item => {
      if (item.id !== data.id) {
        tmpState.push(item)
      }
    })
    state.storeData = tmpState
  },
  DEL_HISTORY_STORE_DATA:(state,data)=>{
    if(state.historyStoreData.length>1)
    {
      state.historyStoreData.length = state.historyStoreData.length -1
    }
  },
  CLEAR_STORE_DATA: (state, data) => {
    state.storeData = []
  },
  SET_SELECT_DATA: (state, id) => { //增加选择数据
    let tmpData = JSON.parse(JSON.stringify(state.selectData))
    let has = false
    let one = ''
    state.storeData.forEach(item => {
      if (item.id == id) {
        one = item
      }
    })
    if (one) {
      tmpData.forEach(item => {
        if (item.id == id) {
          has = true
        }
      })
      if (tmpData.length == 0) {
        state.selectData.push(one)
      } else if (!has) {
        state.selectData.push(one)
      }
    }
  },
  SET_SELECT_MULTIPLE_DATA: (state, data) => {
    state.selectData = JSON.parse(JSON.stringify(data))
  },
  CLEAR_SELECT_DATA: (state, data) => {
    state.selectData = []
  }
}

// 异步方法
const actions = {
  setTreeData({
    commit
  }, data) {
    commit('SET_TREE_DATA', data)
  },
  setStoreData({
    commit
  }, data) {
    commit('SET_STORE_DATA', data)
  },
  setHistoryStoreData({
    commit
  }, data) {
    commit('SET_HISTORY_STORE_DATA', data)
  },
  clearlStoreData({
    commit
  }, data) {
    commit('CLEAR_STORE_DATA', data)
  }
}

// getters
const getters = {
  getTreeData(state) {
    return state.treeData
  },
  getStoreData(state) {
    return state.storeData
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/project.js